<template>
    <span class="app-icon inline-flex shrink-0 items-center" v-html="markup" />
</template>

<script setup lang="ts">
    import { computed } from 'vue'

    import barsIcon from '@/assets/images/bars_icon.svg?raw'
    import homeIcon from '@/assets/images/home_icon.svg?raw'
    import userIcon from '@/assets/images/user_icon.svg?raw'

    /**
     * The portal's own icons, inlined so they can inherit currentColor.
     *
     * The topbar and the manager switcher use bespoke SVGs that predate the
     * re-skin, and no Lucide glyph is a close enough stand-in — the round
     * filled badge is a big part of how the header reads. They live in the repo
     * already, so the markup is imported rather than reproduced.
     */

    const ICONS: Record<string, string> = {
        bars: barsIcon,
        home: homeIcon,
        user: userIcon
    }

    const props = defineProps({
        name: {
            type: String,
            required: true
        }
    })

    const markup = computed(() => ICONS[props.name] ?? '')
</script>

<style scoped>
.app-icon :deep(svg) {
    width: 100%;
    height: 100%;
}
</style>
